export enum MeetingStatus {
  UPCOMING = 'upcoming',
  PROCESSING = 'processing',
  FAILED = 'failed',
  FINISHED = 'finished',
  NO_SHOW = 'no-show',
  SKIPPED = 'skipped',
}
